module.exports = {"411402001":"平原街道","411402002":"长征街道","411402003":"前进街道","411402004":"白云街道","411402005":"东风街道","411402006":"八八街道","411402007":"建设街道","411402011":"解放街道","411402012":"陇海街道","411402100":"谢集镇","411402101":"双八镇","411402103":"观堂镇","411402104":"刘口镇","411402105":"水池铺镇","411402203":"王楼乡","411402204":"李庄乡","411402205":"孙福集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411402.json
// module id = 1775
// module chunks = 0